import {
  ArrowdownCircleIcon,
  PlusIcon,
  Search,
  SupplyChainIcon,
  TrashUpdateIcon,
  UnlinkIcon,
} from "assests";
import { useEffect, useRef, useState } from "react";
import { Button } from "./UI/Button";
import ChipButton from "./UI/ChipButton";
import Divider from "./UI/Divider";
import { Input } from "./UI/Input";
import { useSelector } from "react-redux";
import usePermission from "hooks/usePermission";

const SearchCreatePanelUpdateSupplyChain = ({
  showHeaders = true,
  title,
  btnText,
  subText,
  selectedItems,
  openBulkDeleteModal,
  handleTierUpdate,
  createTxt,
  onChange,
  children,
  onBtnClick,
  inputRefExternal,
  classWidth,
  permissionText,
  isDisabled,
  permissionText2,
}) => {
  const { hasPermission, userPermission } = usePermission();
  const [isHovered, setIshovered] = useState(false);
  const [isTrashbtnHovered, setIsTrashBtnhovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const searchInputRef = useRef(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (inputRefExternal) {
      inputRefExternal.current = searchInputRef.current;
    }
  }, [inputRefExternal]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        (event.key.toLowerCase() === "f" || event.key.toLowerCase() === "F")
      ) {
        event.preventDefault();
        searchInputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div>
      {/* {showHeaders && <HeadersName />} */}
      <div className="flex flex-col md:flex-row flex-wrap justify-center md:justify-between py-[11.5px] lg:pt-4 lg:pb-[26px] px-4 lg:px-6 gap-3 lg:gap-5">
        <div className="flex gap-2 justify-start items-center">
          <h3 className="text-base md:text-lg font-semibold text-global-title leading-5 md:leading-7">
            {title}
          </h3>
          <ChipButton
            className={
              "text-[10px] lg:text-xs text-global-paragraph-3 !h-[22px] !px-1.5  whitespace-nowrap"
            }
            childrenClassName="!tracking-wide"
          >
            {btnText ? btnText : 0}
          </ChipButton>
        </div>

        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex flex-col md:flex-row gap-3">
            <div className="">
              <Button
                variant="secondary"
                onClick={handleTierUpdate}
                className="text-global-paragraph-3 px-3.5 py-2.5 gap-1.5 text-sm w-full md:w-[146px] font-semibold flex"
                onMouseEnter={() => setIshovered(true)}
                onMouseLeave={() => setIshovered(false)}
              >
                <SupplyChainIcon
                  width={20}
                  height={20}
                  strokeColor={
                    isHovered
                      ? "var(--color-icon-fill-secondary-button)"
                      : "var(--color-global-paragraph-3)"
                  }
                />
                <span>Supply Chain</span>
              </Button>
            </div>

            {createTxt &&
              selectedItems.length > 0 &&
              permissionText2 &&
              userPermission("unlink_subsupplier.can") && ( // Check if any orders are selected
                <div className="">
                  <Button
                    variant="secondary"
                    onClick={openBulkDeleteModal}
                    className="text-global-paragraph-3 px-3.5 py-2.5 gap-1.5 text-sm w-full md:w-[99px] font-semibold flex"
                    onMouseEnter={() => setIsTrashBtnhovered(true)}
                    onMouseLeave={() => setIsTrashBtnhovered(false)}
                    isDisabled={isDisabled || false}
                  >
                    <UnlinkIcon
                      width={20}
                      height={20}
                      strokeColor={
                        isTrashbtnHovered
                          ? "var(--color-icon-fill-secondary-button)"
                          : "var(--color-global-paragraph-3)"
                      }
                    />
                    Unlink
                  </Button>
                </div>
              )}

            {createTxt && permissionText && userPermission("create_subsupplier.can") && (
              <div className="flex-1">
                <Button
                  variant="primary"
                  onClick={onBtnClick}
                  className={`px-3.5 py-2.5 gap-1 text-sm leading-5 font-semibold flex ${classWidth}`}
                >
                  <PlusIcon
                    width={20}
                    height={20}
                    fillColor={"var(--color-icon-fill-secondary-button)"}
                  />{" "}
                  {createTxt}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCreatePanelUpdateSupplyChain;
